// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import request from './utils/request' 
import './assets/css/global.css'

import fontawesome from '@fortawesome/fontawesome'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import solid from '@fortawesome/fontawesome-free-solid'
import regular from '@fortawesome/fontawesome-free-regular'
import brands from '@fortawesome/fontawesome-free-brands'

import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import VueAxios from "vue-axios";
import locale from 'element-ui/lib/locale/lang/ja'
import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
    applicationId: 'eba1f3d2-e9f5-4657-88c7-53a3d48d9fdb',
    clientToken: 'pub313d4522df8ef942b72893ff45aef350',
    site: 'ap1.datadoghq.com',
    service: 'leadingwin-shanai-app',
    env: 'staging',				// e.g. 'prod', 'staging-1', 'dev'
    version: '1.0',	// e.g. '1.0.0'
    sessionSampleRate: 100,			// capture 100% of sessions
    sessionReplaySampleRate: 20,	// capture 20% of sessions with replay
    trackResources: true,			// Enable Resource tracking
    trackUserInteractions: true,	// Enable Action tracking
    trackLongTasks: true,			// Enable Long Tasks tracking
});

Vue.config.errorHandler = (error, vm, info) => {
    datadogRum.addError(error, {
        vueInfo: info,
        vueComponent: vm && vm.$options.name,
    });
};

Vue.use(ElementUI, { locale })
 

Vue.use(VueAxios, axios)


fontawesome.library.add(solid)
fontawesome.library.add(regular)
fontawesome.library.add(brands)
Vue.prototype.$baseUrl = process.env.baseUrl

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.prototype.$request = request

Vue.use(ElementUI);

const __build_timestamp__ = '__BUILD_TIME__';
console.log('Build timestamp:', __build_timestamp__);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js